import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { FiClock, FiAlertCircle, FiCheckCircle, FiTruck } from "react-icons/fi";

const MediaFornitoriCard = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("./ordini_urgenti.json")
      .then((res) => res.json())
      .then((json) => {
        const ordini = json?.STATO_ORDINI?.flat() || [];
        const oggi = new Date();
        const unMeseFa = new Date();
        unMeseFa.setMonth(oggi.getMonth() - 1);

        const perFornitore = {};

        ordini.forEach((o) => {
          const dataOrdine = new Date(o["Data Ordine"]);
          const dataFine = o["Data Completamento ODP/ODPV"] ? new Date(o["Data Completamento ODP/ODPV"]) : null;
          
          if (dataOrdine >= unMeseFa && dataFine && !isNaN(dataFine)) {
            const diffDays = Math.ceil((dataFine - dataOrdine) / (1000 * 60 * 60 * 24));
            const fornitore = o["Ragione sociale"] || "N/A";
            const targetSpedizione = parseInt(o["Giorni Spedizione"]) || 0;

            if (!perFornitore[fornitore]) {
              perFornitore[fornitore] = { 
                totaleGiorni: 0, 
                count: 0, 
                target: targetSpedizione 
              };
            }
            perFornitore[fornitore].totaleGiorni += diffDays;
            perFornitore[fornitore].count += 1;
          }
        });

        const risultato = Object.entries(perFornitore)
          .map(([fornitore, val]) => {
            const media = parseFloat((val.totaleGiorni / val.count).toFixed(1));
            // LOGICA RICHIESTA: Ritardo solo se media > (target + 2 giorni)
            // Quindi se target è 2, ritardo scatta da 5.0 in su.
            const isNegative = media >= (val.target + 3); 
            
            return {
              fornitore,
              media,
              target: val.target,
              count: val.count,
              isNegative
            };
          })
          .sort((a, b) => b.isNegative - a.isNegative || a.media - b.media);

        setData(risultato);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="ombra card tb" style={{ 
        borderRadius: "12px", border: "1px solid #dee2e6", height: "400px", 
        display: "flex", flexDirection: "column", overflow: "hidden", backgroundColor: "#fff" 
    }}>
      <div className="p-3 bg-light border-bottom d-flex justify-content-between align-items-center">
        <span style={{ fontWeight: "700", fontSize: "0.75rem", color: "#495057", letterSpacing: "1px" }}>
            MEDIA GIORNI FORNITORI (30 giorni)
        </span>
      </div>

      <div className="scroll-container" style={{ flexGrow: 1, overflowY: "auto" }}>
        <style>{`
          .scroll-container::-webkit-scrollbar { width: 4px; }
          .scroll-container::-webkit-scrollbar-track { background: #f8f9fa; }
          .scroll-container::-webkit-scrollbar-thumb { background: #ccc; border-radius: 10px; }
          .table-sm td { padding: 12px 8px !important; }
        `}</style>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center h-100">
            <Spinner animation="border" variant="danger" size="sm" />
          </div>
        ) : (
          <table className="table table-hover mb-0" style={{ fontSize: '0.75rem' }}>
            <thead className="bg-white sticky-top" style={{ zIndex: 1, boxShadow: '0 2px 2px -1px rgba(0,0,0,0.05)' }}>
              <tr>
                <th className="border-0 text-muted ps-3">FORNITORE</th>
                <th className="border-0 text-muted text-center">SISTEMA</th>
                <th className="border-0 text-muted text-center">REALE</th>
                <th className="border-0 text-muted text-end pe-3">STATUS</th>
              </tr>
            </thead>
            <tbody>
              {data.map((f, i) => (
                <tr key={i} style={{ verticalAlign: 'middle' }}>
                  <td className="ps-3">
                    <div className="fw-bold text-truncate" style={{ maxWidth: "130px" }}>{f.fornitore}</div>
                    <div style={{ fontSize: '0.65rem', color: '#999' }}>{f.count} ordini completati</div>
                  </td>
                  <td className="text-center text-muted">{f.target} gg</td>
                  <td className="text-center">
                    <span className="fw-bold" style={{ fontSize: '0.8rem' }}>{f.media} gg</span>
                  </td>
                  <td className="text-end pe-3">
                    {f.isNegative ? (
                      <span className="badge rounded-pill bg-danger-subtle text-danger border border-danger-alpha d-inline-flex align-items-center gap-1" style={{ padding: '5px 10px' }}>
                        <FiAlertCircle size={12} /> RITARDO
                      </span>
                    ) : (
                      <span className="badge rounded-pill bg-success-subtle text-success border border-success-alpha d-inline-flex align-items-center gap-1" style={{ padding: '5px 10px' }}>
                        <FiCheckCircle size={12} /> IN TARGET
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default MediaFornitoriCard;